import { motion } from "framer-motion";
import { Reveal } from "../shared/Reveal";
import CTAButton from "../shared/CTAButton";
import { REVISION } from "../../data/homeContent";

export default function Revision() {
  return (
    <section className="bg-primary text-primary-foreground py-20 md:py-28 lg:py-36" data-testid="revision-section">
      <div className="container-psv grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <span className="eyebrow text-accent mb-4 block">{REVISION.eyebrow}</span>
            <h2 className="font-serif font-medium text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              {REVISION.heading}
            </h2>
            <p className="mt-6 text-lg text-primary-foreground/80 font-light leading-relaxed max-w-xl">
              {REVISION.text}
            </p>
            <p className="mt-4 text-sm text-primary-foreground/60 italic">{REVISION.note}</p>
            <div className="mt-9">
              <CTAButton to="/#case-review" variant="accent" size="lg" testId="revision-cta-btn">
                Request a Revision Case Review
              </CTAButton>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {REVISION.examples.map((ex, i) => (
              <motion.div
                key={ex}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="border border-primary-foreground/15 rounded-lg px-5 py-4 text-[15px] text-primary-foreground/85 hover:border-accent transition-colors"
              >
                {ex}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
